export default class BlockGallerySlider {
	static init() {
		let swipers = document.querySelectorAll('.block-gallery-swiper');

		swipers.forEach( (swiper) => {
			const prev = swiper.querySelector(".gallery-button-prev");
			const next = swiper.querySelector(".gallery-button-next");
			new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});
		});
	}
}
